import { Resource } from './resource';
import gql from 'graphql-tag';

export class StatisticResource extends Resource {
  public static async periodicalStats(period: number, quantity: number, dateStart: Date, userId: number) {
    return await this.query(
      {
        query: gql`
          query($period: Int, $quantity: Int, $dateStart: DateTime, $userId: Int) {
            periodicalStats(periodInput: { period: $period, quantity: $quantity, dateStart: $dateStart }, userId: $userId)
          }
        `,
        variables: { period, quantity, dateStart, userId }
      },
      'periodicalStats'
    );
  }
}
